<template>
  <div>
    <b-modal
      ref="modal"
      title="Download XML"
      header-class="border-bottom-0"
      size="xs"
    >
      <div class="container-fluid">
        <date-input
          alias="Data inicial"
          v-model="searchForm.date_start"
        ></date-input>

        <date-input
          alias="Data final"
          v-model="searchForm.date_end"
        ></date-input>
      </div>

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="downloadXml()"
        >
          <i class="fas fa-download"></i> Download
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data: function() {
      return {
        searchForm: {
          date_start: moment()
            .clone()
            .startOf("month")
            .format("YYYY-MM-DD"),
          date_end: moment()
            .clone()
            .endOf("month")
            .format("YYYY-MM-DD")
        }
      };
    },

    methods: {
      open() {
        this.$refs.modal.show();
      },

      downloadXml() {
        this.$store.commit("showLoading");
        this.$store
          .dispatch("xml/download", this.searchForm)
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "xmlzipped.zip");
            document.body.appendChild(link);
            link.click();
            this.$store.commit("hideLoading");
          })
          .catch(error => {
            this.error = error;

            this.$store.commit("hideLoading");
          });
      }
    }
  };
</script>

<style>
</style>